// Static pricing data — mirrors the backend /api/pricing payload so the
// calculator works even when the backend is not running. When the backend
// is available, the live data takes precedence.
export const PRICING = {
  screens: [
    { id: "2.4", label: '2.4"', name: '2.4" Οθόνη', desc: "Compact, για επαγγελματικές κάρτες & ένθετα" },
    { id: "5.0", label: '5.0"', name: '5.0" Οθόνη', desc: "Standard, για brochures & mailers" },
    { id: "7.0", label: '7.0"', name: '7.0" Οθόνη', desc: "Premium, για παρουσιάσεις & kits" },
  ],
  breakpoints: [100, 200, 500, 1000, 5000],
  matrix: {
    "2.4": { 100: 40.0, 200: 28.5, 500: 27.0, 1000: 25.0, 5000: 20.0 },
    "5.0": { 100: 70.0, 200: 49.95, 500: 45.0, 1000: 41.5, 5000: 36.0 },
    "7.0": { 100: 85.0, 200: 56.4, 500: 52.5, 1000: 50.0, 5000: 43.0 },
  },
  includes: [
    "Πλήρης παραγωγή & συναρμολόγηση του video brochure",
    "Εισαγωγή / εκτελωνισμός & διαχείριση",
    "Φόρτωση εξατομικευμένου περιεχομένου στις οθόνες",
    "Παράδοση στη διεύθυνσή σας (Δωρεάν εντός Ελλάδος)",
  ],
  min_qty: 100,
  max_qty: 5000,
};

// Discount codes available client-side as a fallback.
export const DISCOUNTS = {
  WELCOME5: { code: "WELCOME5", percent: 5, label: "-5% έκπτωση" },
  "10ACTIVEOFF": { code: "10ACTIVEOFF", percent: 10, label: "-10% έκπτωση" },
  LARIVIERA: { code: "LARIVIERA", percent: 10, label: "-10% έκπτωση" },
  SOCIAL20: { code: "SOCIAL20", percent: 20, label: "-20% έκπτωση" },
};
